export const LOADING_STATUSES = {
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error'
};